import { render, staticRenderFns } from "./FoodDistributionFamilyView.vue?vue&type=template&id=1bcae672&"
import script from "./FoodDistributionFamilyView.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionFamilyView.vue?vue&type=script&lang=js&"
import style0 from "./FoodDistributionFamilyView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports